import React from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col, Button } from "reactstrap"

//Import Countdown
import Countdown from "react-countdown"

//Import Images
import logodark from "../../assets/images/logo-dark.png";
import maintanence from "../../assets/images/Maintenance-pana.svg"

const PagesComingsoon = () => {
  
    //meta title
    document.title = "Coming Soon | Mildmay - EHub";

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-white">
          <i className="fas fa-home h2" />
        </Link>
      </div>

      <div className="my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg="12">
              <div className="text-center">
                <Row className="justify-content-center mt-5">
                  <Col sm="7">
                    <div className="maintenance-img">
                      <img
                        src={maintanence}
                        className="img-fluid mx-auto d-block"
                      />
                      </div>
                  </Col>
                </Row>
                <h4 className="mt-6">Coming Soon to Mildmay BRIDGE</h4>
                <p className="d-grid gap-5">
                  Hey. We know you are excited about this new feature. We are too, and are working hard to make it available at the nearest opportune time. Hang tight!
                </p>
                  <Col md="12">
                    <div className="d-grid gap-5">
                    <Link to="/dashboard">
                      <Button
                        color="primary"
                        className="btn"
                        >
                          <i className="mdi md-plus me-1" />
                          Go back Home
                        </Button>
                        </Link>
                    </div>
                  </Col>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PagesComingsoon
